module.exports = function (app) {
    "use strict";
    app.controller('pages.groupInfo', ["$state", "$scope", "services", "$timeout", "employerUtility", "sessionData", "coremetrics",
        function ($state, $scope, services, $timeout, employerUtility, sessionData, coremetrics) {

        // ========================================================================
        // NOTE: this is the controller for general-info.html and contacts.html
        // ========================================================================

        // Sidebar
        $scope.sidebar = {
            breadCrumb: {
                primary: {
                    title: "Groups",
                    state: "groupList"
                },
                secondary: {
                    title: $state.params.groupNumber +" "+$state.params.groupName,
                    subTitle: $state.params.status
                }
            },
            links: [
                {
                    heading: "General Information",
                    label: "General Information",
                    state: "groupInfo.generalInfo",
                    description: "General Information"
                }, {
                    heading: "Contacts",
                    label: "Group Contacts",
                    state: "groupInfo.contacts",
                    description: "Group Contacts"
                }]
        };

        $scope.contactSections = [  ];
        $scope.pageTitle="Group Contacts";
        document.title = $state.params.groupNumber + " " + 'Group General Info';

        $scope.generalInfoSections = [
            {
                expand: true,
                hasItems: false
            },
            {
                name: "Eligibility",
                src: 'group-info/general-info.employerTemplate.html/pages/clientAndGroup/eligibility',
                disableSort: true,
                hasItems: false,
                pagination: {
                    itemsPerPage: 1000,
                    page: 1
                },
                titles: [
                    {
                        name: "Dependent Type",
                        dataKey: "dependentType",
                        selectAll: true
                    },
                    {
                        name: "Eligible to Age",
                        dataKey: "eligibleToAge",
                        selectAll: true
                    },
                    {
                        name: "Terminate",
                        dataKey: "terminate",
                        selectAll: true
                    }

                ],
                rows: [
                    //{
                    //    dependentType: "Disabled Dependent",
                    //    eligibleToAge: "Unlimited",
                    //    terminate: "No Deletion"
                    //},
                    //{
                    //    dependentType: "Regular",
                    //    eligibleToAge: "26",
                    //    terminate: "First of Month Following Birthdate"
                    //}
                ],
                rightColumns:[
                    //{
                    //    icon:"approved",
                    //    desc: "Dependents"
                    //},
                    //{
                    //    icon:"decline",
                    //    desc: "Dependents"
                    //}
                ],
                leftColumns:[
                    //{
                    //    icon:"decline",
                    //    desc: "Domestic Patterns"
                    //},
                    //{
                    //    icon:"decline",
                    //    desc: "Students Reporting"
                    //}
                ]
            },
            {
                name: "Products",
                src: 'group-info/general-info.employerTemplate.html/pages/clientAndGroup/products',
                hasItems: false,
                products: [
                    {
                        name: "Service - WebMD Rewards",
                        status: "Active",
                        startDate: "01/01/2017",
                        endDate: "12/31/2017",
                        nextRenewal: "01/01/2015",
                        contractPeriod: "12 months",
                        billingMethod: "Claims"
                    },

                    {
                        name: "Service - Prism Rewards",
                        status: "Cancelled",
                        startDate: "01/01/2017",
                        endDate: "12/31/2017",
                        nextRenewal: "01/01/2015",
                        contractPeriod: "12 months",
                        billingMethod: "Claims"
                    }
                ]
            }
            ,
            {
                name: "Report Codes",
                src: 'group-info/general-info.employerTemplate.html/pages/clientAndGroup/reports',
                disableSort: true,
                hasItems: false,
                pagination: {
                    itemsPerPage: 1000,
                    page: 1
                },
                titles: [
                    {
                        name: "Type",
                        dataKey: "type",
                        selectAll: true
                    },
                    {
                        name: "Code",
                        dataKey: "strCodes",
                        selectAll: true
                    }
                ],
                rows: [
                    //{
                    //    type: "ALPHA PAY",
                    //    code: "######"
                    //},
                    //{
                    //    type: "PAY LOCATION (LU)",
                    //    code: "######"
                    //}
                ]
            },
            {
                name: "Identity Theft Protection",
                src: 'group-info/general-info.employerTemplate.html/pages/clientAndGroup/id-theft-protection',
                status: "",
                vendor: "",
                // protectionStart: "01/01/2017",
                // protectionEnd: "12/31/2017",
                hasItems: false
            }
        ];
        $scope.contactsServiceCallIsRunning = true;
        $scope.sidebar.breadCrumb.primary.title = 'Groups for ' + sessionData.employerInfo.planAdministrator.company;
        var useStub = false;
        var handleServiceSuccess = function(retObj, theCaller) {
            if (retObj && retObj.data && retObj.data.payload && retObj.data.payload) {
                $scope.serviceReturnedItems = true;
                var thePayload =  retObj.data.payload;
                switch (theCaller) {

                    case 'GenInfoSvc':
                        // NOTE: this data displays in general-info.html w the details in general-info-detail.html
                        coremetrics.pageviewTag('EMPLOYERS:CLIENT GROUPS:GROUP GENERAL INFORMATION', 'EMPLOYERS:CLIENT GROUPS');
                        $scope.genInfoServiceCallIsRunning = false;
                        thePayload.name =  "Group General Information";
                        thePayload.expand = true;
                        thePayload.src = 'group-info/general-info.employerTemplate.html/pages/clientAndGroup/general-info-detail';
                        thePayload.hasItems = true;
                        $scope.generalInfoSections[0] = thePayload;
                        // $scope.$apply();
                        break;
                    case 'EligibilitySvc':
                        // NOTE: this data displays in general-info.html w the details in eligibility.html
                        $scope.eligibleServiceCallIsRunning = false;
                        var objEligibility = employerUtility.makeEligibilityObj(thePayload);
                        $scope.generalInfoSections[1].hasItems = true;
                        $scope.generalInfoSections[1].rows = objEligibility.dependentTypes;
                        // If all the Eligibilities are "decline" we do not show the sub table
                        $scope.showSubTable = employerUtility.showEligibilitySubTable (objEligibility.arrLeft, objEligibility.arrRight);
                        $scope.generalInfoSections[1].rightColumns = objEligibility.arrRight;
                        $scope.generalInfoSections[1].leftColumns = objEligibility.arrLeft;
                        break;
                    case 'ProductsSvc':
                        // NOTE: this data displays in general-info.html w the details in contacts.html
                        $scope.productsServiceCallIsRunning = false;
                        $scope.generalInfoSections[2].hasItems = true;
                        $scope.generalInfoSections[2].products = thePayload;
                        // $scope.contactSections = thePayload;
                        break;
                    case 'ReportCodesSvc':
                        // NOTE: this data displays in general-info.html w the details in report.html
                        $scope.reportCodeServiceCallIsRunning = false;  // 3
                        var theRows = employerUtility.makeReportCodesArrayForUi(thePayload);
                        $scope.generalInfoSections[3].hasItems = true;
                        $scope.generalInfoSections[3].rows = theRows;
                        break;
                    case 'IdTheftSvc':
                        $scope.idTheftServiceCallIsRunning = false;
                        var idTheftSec = $scope.generalInfoSections[4];
                        idTheftSec.hasItems = true;
                        idTheftSec.vendor = thePayload;
                        idTheftSec.status = 'Opt-In'
                        break;
                    case 'ContactsSvc':
                        // NOTE: this is for the CONTACTS TAB not the General Info tab
                        $scope.contactsServiceCallIsRunning = false;
                        $scope.contactSections = thePayload;
                        break;
                    default:
                        alert('This is an unexpected caller.')
                        break;
                }

            } else {
                $scope.genInfoServiceCallIsRunning = false;
                $scope.eligibleServiceCallIsRunning = false;
                $scope.productsServiceCallIsRunning = false;
                $scope.reportCodeServiceCallIsRunning = false;
                $scope.idTheftServiceCallIsRunning = false;
                $scope.contactsServiceCallIsRunning = false;
                // $scope.feedback.showFeedback("The service returned something unexpected.", "failure");
                alert("The service returned something unexpected.", "failure");
            }
        }
        var handleServiceFailure = function(err, theCaller) {
            // $scope.serviceReturnedItems = false;
            $scope.genInfoServiceCallIsRunning = (theCaller == 'GenInfoSvc') ? false : $scope.genInfoServiceCallIsRunning;
            $scope.eligibleServiceCallIsRunning =  (theCaller == 'EligibilitySvc') ? false : $scope.eligibleServiceCallIsRunning;
            $scope.productsServiceCallIsRunning = (theCaller == 'ProductsSvc') ? false : $scope.productsServiceCallIsRunning;
            $scope.reportCodeServiceCallIsRunning = (theCaller == 'ReportCodesSvc') ? false : $scope.reportCodeServiceCallIsRunning;
            $scope.contactsServiceCallIsRunning = (theCaller == 'ContactsSvc') ? false : $scope.contactsServiceCallIsRunning;
            $scope.idTheftServiceCallIsRunning = (theCaller == 'IdTheftSvc') ? false : $scope.idTheftServiceCallIsRunning;
            if (err.data && err.data.baseMessage && err.data.baseMessage.returnCodeDescription) {
                console.error(err.data.baseMessage.returnCodeDescription)
                // var theMsg = 'No items found.';
                console.error('No items found for service = ' + theCaller);
                // $scope.feedback.showFeedback(theMsg, "notification");
                // alert(theMsg);
            } else {
                // $scope.feedback.showFeedback("We are unable to process the request right now, Please try again later.", "failure");
                alert("We are unable to process the request right now, Please try again later.");
            }
        }
        $scope.$watch(function(){
            return $state.$current.name
        }, function(newVal, oldVal){
            if (newVal == 'groupInfo.contacts') {
                coremetrics.pageviewTag('EMPLOYERS:CLIENT GROUPS:GROUP CONTACTS', 'EMPLOYERS:CLIENT GROUPS');
            } });
        // ===========================================================================
        // NOTE: this file is the controller for general-info.html and contacts.html
        // ===========================================================================

        var makeXhrCall = function(theMethod, theCaller) {
            theMethod.then(function (retObj) {
                handleServiceSuccess(retObj, theCaller);
            }, function (err) {
                handleServiceFailure(err, theCaller);
            });
        }
        var getItemsFromService = function(groupNumber, theCaller) {
            if (useStub && (theCaller == 'xxContactsSvc')) {
                populateStubArray();
                return;
            }
            var gn = groupNumber;
            var theSvc = services.eprsvc.groupInformation();
            if (theCaller =='GenInfoSvc') {
                $scope.genInfoServiceCallIsRunning = true;
                makeXhrCall(theSvc.getGeneralInfo(gn), theCaller);

            } else if (theCaller =='EligibilitySvc') {
                $scope.eligibleServiceCallIsRunning = true;
                makeXhrCall(theSvc.getEligibility(gn), theCaller);

            } else if (theCaller =='ProductsSvc') {
                $scope.productsServiceCallIsRunning = true;
                makeXhrCall(theSvc.getProducts(gn), theCaller);

            } else if (theCaller =='ReportCodesSvc') {
                $scope.reportCodeServiceCallIsRunning = true;
                makeXhrCall(theSvc.getReportCodes(gn), theCaller);

            } else if (theCaller =='ContactsSvc') {
                $scope.contactsServiceCallIsRunning = true;
                makeXhrCall(theSvc.getContacts(gn), theCaller);

            } else if (theCaller =='IdTheftSvc') {
                $scope.idTheftServiceCallIsRunning = true;
                makeXhrCall(theSvc.getIdTheft(gn), theCaller);
            } else {
                alert('We don\'t expect to be on this page.')
            }
        }
        var stateGn = $state.params.groupNumber;

        getItemsFromService(stateGn, 'GenInfoSvc');
        getItemsFromService(stateGn, 'EligibilitySvc');
        getItemsFromService(stateGn, 'ProductsSvc');
        getItemsFromService(stateGn, 'ReportCodesSvc');
        getItemsFromService(stateGn, 'IdTheftSvc');
        getItemsFromService(stateGn, 'ContactsSvc'); // This displays in the Contacts tab

        $scope.collapseAllRows=function(){
            $scope.expandList=false;
            for(var i=0;i<$scope.generalInfoSections.length;i++){
                $scope.generalInfoSections[i].expand=false;
            } };

        $scope.checkExpand=function(){
            var allExpanded=true;
            for(var i=0;i<$scope.generalInfoSections.length;i++){
                if(!$scope.generalInfoSections[i].expand){
                    allExpanded=false;
                    break;
                }
            }
            $scope.expandList=allExpanded;
        };

        $scope.expandCollapseAllRows=function(){
            $scope.expandList=!$scope.expandList;
            for(var i=0;i<$scope.generalInfoSections.length;i++){
                $scope.generalInfoSections[i].expand=$scope.expandList;
            }
        };
    }]);
    // the return ed routes array is in group-list
};
